var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/outlined/download"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.95 19.1164C13.4382 18.6283 14.2296 18.6283 14.7178 19.1164L19.2506 23.6492L19.2506 6.66699C19.2506 5.97664 19.8102 5.41699 20.5006 5.41699C21.1909 5.41699 21.7506 5.97664 21.7506 6.66699L21.7506 23.6492L26.2834 19.1164C26.7715 18.6283 27.563 18.6283 28.0511 19.1164C28.5393 19.6046 28.5393 20.3961 28.0511 20.8842L21.3845 27.5509C20.8963 28.039 20.1048 28.039 19.6167 27.5509L12.95 20.8842C12.4619 20.3961 12.4619 19.6046 12.95 19.1164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.16724 23.7503C7.85759 23.7503 8.41724 24.31 8.41724 25.0003V27.8159L12.685 32.0837H32.5839V25.0003C32.5839 24.31 33.1435 23.7503 33.8339 23.7503C34.5243 23.7503 35.0839 24.31 35.0839 25.0003V33.3337C35.0839 34.024 34.5243 34.5837 33.8339 34.5837H12.1672C11.8357 34.5837 11.5178 34.452 11.2834 34.2175L6.28335 29.2175C6.04893 28.9831 5.91724 28.6652 5.91724 28.3337V25.0003C5.91724 24.31 6.47688 23.7503 7.16724 23.7503Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.7e8c733cd6d16ef26ac6711ad9814075.svg";
export { ForwardRef as ReactComponent };